<div>
  <h3>General banners settings</h3>
  <div class="container-wrap">
    <div class="row-wrap multi-control" [formGroup]="parentFormGroup">
      <div class="column-wrap interval-wrap">
        <mat-form-field appearance="fill" class="item">
          <mat-label>Interval (ms)</mat-label>
          <input matInput type="number" min="1000" step="500" formControlName="interval" autocomplete="off">
          @if (parentFormGroup.get('interval').errors) {
            <mat-error>This field is required if you have banners</mat-error>
          }
        </mat-form-field>
        <span class="hint">If not empty - banners will be autoplayed</span>
        <span></span>
      </div>
      <div class="column-wrap">
        <color-picker class="dots-color-picker" [title]="'Set dots color?'"
          [showColorPicker]="bannersConfig.setDotsColor" [hexColor]="bannersConfig.color"
          [parentFormGroup]="parentFormGroup" [controlName]="'color'"
        [showColorPickerControlName]="'setDotsColor'"></color-picker>
      </div>
    </div>
  </div>
</div>
